<template>
  <div>
    <!-- <el-card class="box-card">
      <el-form
        ref="searchForm"
        :model="searchForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="名称" prop="name" class="form-bottom">
              <el-input
                v-model="searchForm.name"
                placeholder="请输入名称"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-button
              :size="buttonSize"
              type="primary"
              @click="pageList"
              icon="el-icon-search"
              >查询</el-button
            >
            <el-button
              :size="buttonSize"
              type="primary"
              @click="reset"
              icon="el-icon-refresh"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </el-card> -->

    <el-card class="box-card" style="margin-top: 20px">
      <el-row :span="24">
        <el-col :span="12">
          <el-button
            v-auth="'/versionManagement/addApp'"
            :size="buttonSize"
            type="primary"
            @click="addFormVisible = true"
            icon="el-icon-plus"
            >添加</el-button
          >
          <!-- <el-button
            :size="buttonSize"
            type="danger"
            @click="batchDeleteRole"
            icon="el-icon-minus"
            >批量删除</el-button
          > -->
        </el-col>
        <!-- <el-col style="text-align: right" :span="12">
          <el-button
            :size="buttonSize"
            type="primary"
            @click="importFormVisible = true"
            icon="el-icon-download"
            >导入</el-button
          >
          <el-button
            :size="buttonSize"
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
            >导出</el-button
          >
        </el-col> -->
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        v-loading="tableLoading"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="appVersion" label="版本"></el-table-column>
        <el-table-column prop="showBuy" label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.showBuy == '1'">开</div>
            <div v-else>关</div>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span
                @click="editVersion(scope.row)"
                v-auth="'/versionManagement/updateApp'"
                >编辑</span
              >
              <span
                @click="deleteApp(scope.row.id)"
                v-auth="'/versionManagement/deleteApp'"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!tableLoading"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" left>
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入名称"
            auto-complete="off"
            maxlength="48"
          ></el-input>
        </el-form-item>
        <el-form-item label="App管理" prop="appType">
          <!-- searchForm.isSolved -->
          <el-select
            size="medium"
            collapse-tags
            v-model="addForm.appType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in replyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本号" prop="appVersion">
          <el-input
            v-model="addForm.appVersion"
            placeholder="请输入版本号"
            auto-complete="off"
            maxlength="48"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否展示" prop="showBuy">
          <!-- @change="stateActive(scope.row)" -->
          <el-switch
            v-model="addForm.showBuy"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="addFormVisible = false"
          >取 消</el-button
        >
        <el-button :size="buttonSize" type="primary" @click="addApp"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="editForm.name"
            placeholder="请输入名称"
            auto-complete="off"
            maxlength="48"
          ></el-input>
        </el-form-item>
        <el-form-item label="App管理" prop="appType">
          <!-- searchForm.isSolved -->
          <el-select
            size="medium"
            collapse-tags
            v-model="editForm.appType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in replyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本号" prop="appVersion">
          <el-input
            v-model="editForm.appVersion"
            placeholder="请输入版本号"
            auto-complete="off"
            maxlength="48"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否展示" prop="showBuy">
          <!-- @change="stateActive(scope.row)" -->
          <el-switch
            v-model="editForm.showBuy"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="editFormVisible = false"
          >取 消</el-button
        >
        <el-button :size="buttonSize" type="primary" @click="updateApp"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <!-- size="small" -->
        <el-button :size="buttonSize" type="primary" icon="el-icon-upload"
          >点击上传</el-button
        >
        <div slot="tip" class="el-upload__tip">
          只能上传xls、xlsx文件，且不超过1024kb
        </div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="角色名称"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="buttonSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
          >导入数据</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      replyList: [{
        id: '1',
        name: 'Android'
      }, {
        id: '2',
        name: 'IOS'
      }, {
        id: '3',
        name: '小程序'
      }],
      tableLoading: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        name: ""
      },
      styles: {
        width: "300px"
      },
      selectParams: {
        clearable: true,
        placeholder: "请选择资源"
      },
      treeParams: {
        clickParent: true,
        filterable: false,
        "check-strictly": true,
        "default-expand-all": true,
        "expand-on-click-node": false,
        "check-on-click-node": true,
        data: [],
        props: {
          children: "resources",
          label: "name",
          disabled: "disabled",
          value: "id"
        }
      },
      addForm: {
        name: "",
        version: 1
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 48,
            message: "角色名称长度在1到48个字"
          }
        ],
        appType: [
          {
            required: true,
            message: "请选择",
            trigger: "blur"
          }
        ]
      },
      editForm: {
        name: "",
        version: 1
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 48,
            message: "角色名称长度在1到48个字"
          }
        ],
        appType: [
          {
            required: true,
            message: "请选择",
            trigger: "blur"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      fileAction: `${process.env.BASE_URL}/role/upload`,
      fileList: [],
      loading: false,
      buttonSize: document.body.clientWidth < 992 ? "mini" : ""
    };
  },
  methods: {
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    // 列表
    pageList () {
      this.tableLoading = true
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      // this.searchForm.sortName = this.page.sortName;
      // this.searchForm.sortOrder = this.page.sortOrder;
      this.api.versionManagement
        .pageListApp(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          console.log(this.page.rows, 6666);
          this.page.total = result.data.total;
          this.tableLoading = false
        })
        .catch(error => {
          this.tableLoading = false
          console.log(error);
        });
    },
    addApp () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          // this.addForm.resources.forEach(
          //   (e, index) => (this.addForm.resources[index] = { id: e })
          // );
          this.api.versionManagement
            .addApp(this.addForm)
            .then(result => {
              this.addFormVisible = false;
              this.$message({
                type: "success",
                message: result.message
              });
              this.pageList();
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    editVersion (row) {
      this.editForm = row
      this.editForm.appType = row.appType + ''
      this.editFormVisible = true;
    },
    updateApp () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          // this.editForm.resources.map(
          //   (e, index) => (this.editForm.resources[index] = { id: e })
          // );
          this.api.versionManagement
            .updateApp(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteApp (id) {
      console.log(id);
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.versionManagement
            .deleteApp([
              {
                id: id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteRole () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.role
            .deleteRole(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel () {
      this.loading = true;
      this.api.role
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData () {
      this.api.role
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getResourceTree () {
      this.api.resource
        .getResourceTree()
        .then(result => {
          this.treeParams.data = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleNodeClick (data, node, vm) { }
  },
  mounted () {
    this.pageList();
    this.getResourceTree();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/versionManagement/index.vue